// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"view-publish_wrapper__qcQ0S"};